import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { userSessionFeature } from 'app/state/user-session/user-session.reducer';

import { UserSessionEffects } from './user-session.effects';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(userSessionFeature), EffectsModule.forFeature([UserSessionEffects])],
})
export class UserSessionStateModule {}
